import React from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";

const ChatTopBar = ({
  chatName,
  isLocked,
  onToggleLock,
  canToggleLock,
  showDeleteGroup,
  onDeleteGroup,
}) => (
  <div className="flex items-center justify-between gap-2 p-2 border-b border-gray-200 bg-white rounded-t-md">
    <div className="min-w-0">
      <p className="text-sm font-semibold truncate">{chatName || "Select a chat"}</p>
      <p className="text-[11px] text-gray-500">{isLocked ? "Chat locked" : "Chat unlocked"}</p>
    </div>
    <div className="flex items-center gap-1">
      <button
        onClick={onToggleLock}
        disabled={!canToggleLock}
        className="p-1.5 border rounded-md bg-gray-100 hover:bg-gray-200"
        title={!canToggleLock ? "Only group creator can lock/unlock" : isLocked ? "Unlock chat" : "Lock chat"}
      >
        {isLocked ? <LockOutlinedIcon fontSize="small" /> : <LockOpenOutlinedIcon fontSize="small" />}
      </button>
      {showDeleteGroup ? (
        <button
          onClick={onDeleteGroup}
          className="text-xs px-2 py-1 border rounded-md bg-red-100 text-red-700 hover:bg-red-200"
        >
          Delete group
        </button>
      ) : null}
    </div>
  </div>
);

export default ChatTopBar;
